<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加交易对</el-button
    >
    <el-dialog
      title="添加交易对"
      width="650px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <el-form
        label-width="240px"
        :model="tradePair"
        :rules="rules"
        ref="tradePair"
      >
        <el-form-item label="交易目标币种：" prop="exchangeCoin">
          <!-- <el-select v-model="tradePair.exchangeCoin" placeholder="请选择">
                       <el-option
                         v-for="item in coinList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"
                       ></el-option>
                     </el-select>-->
          <coin-select
            :coinType="tradePair.exchangeCoin"
            @value="(val) => (tradePair.exchangeCoin = val)"
          />
        </el-form-item>
        <el-form-item label="锚定币种：" prop="anchoredCoin">
          <coin-select
            :coinType="tradePair.anchoredCoin"
            @value="(val) => (tradePair.anchoredCoin = val)"
          />
        </el-form-item>
        <el-form-item label="价格精度：" prop="defaultPrecision">
          <el-input-number
            v-model="tradePair.defaultPrecision"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="数量精度：" prop="amountPrecision">
          <el-input-number
            v-model="tradePair.amountPrecision"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="是否展示：" prop="shouldDisplay">
          <el-switch
            v-model="tradePair.shouldDisplay"
            active-color="#13ce66"
          ></el-switch>
        </el-form-item>
        <el-form-item label="是否支持交易：" prop="supportTrade">
          <el-switch
            v-model="tradePair.supportTrade"
            active-color="#13ce66"
          ></el-switch>
        </el-form-item>
        <el-form-item label="是否支持下买单：" prop="supportBid">
          <el-switch
            v-model="tradePair.supportBid"
            active-color="#13ce66"
          ></el-switch>
        </el-form-item>
        <el-form-item label="最早买单时间：" prop="earliestBidTime">
          <el-date-picker
            v-model="earliestBidTime"
            type="datetime"
            placeholder="选择最早买单时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否支持下卖单：" prop="supportAsk">
          <el-switch
            v-model="tradePair.supportAsk"
            active-color="#13ce66"
          ></el-switch>
        </el-form-item>
        <el-form-item label="最早卖单时间：">
          <el-date-picker
            v-model="earliestAskTime"
            type="datetime"
            placeholder="选择最早卖单时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否风险系数高:" prop="highRisk">
          <el-switch
            v-model="tradePair.highRisk"
            active-color="#13ce66"
          ></el-switch>
        </el-form-item>
        <el-form-item label="交易买费率:" prop="bidFeeRate">
          <el-input v-model="tradePair.bidFeeRate" />
        </el-form-item>
        <el-form-item label="交易卖费率:" prop="askFeeRate">
          <el-input v-model="tradePair.askFeeRate" />
        </el-form-item>
        <el-form-item label="最小交易额:" prop="minimumTradeVolume">
          <el-input v-model="tradePair.minimumTradeVolume" />
        </el-form-item>
        <el-form-item label="上线时间：">
          <el-date-picker
            v-model="tradePair.onlineTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择上线时间"
          ></el-date-picker>
          <p style="color: #999">(备注：用于显示计算倒计时时间，不代表真实上线时间)</p>
        </el-form-item>
        <el-form-item
          label="真实上线时间(运营勿动!):"
          prop="realOnlineTime"
          class="realkline-wrap"
        >
          <el-date-picker
            v-model="realOnlineTime"
            type="datetime"
            placeholder="真实上线时间(运营勿动!)"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否属于期货">
          <el-switch
            v-model="tradePair.futures"
            active-color="#13ce66"
          ></el-switch>
        </el-form-item>
        <el-form-item v-if="tradePair.futures" label="期货兑换开始时间">
          <el-date-picker
            v-model="beginTime"
            type="datetime"
            placeholder="期货兑换开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-if="tradePair.futures" label="期货详情网址">
          <el-input v-model="tradePair.websiteUrl"></el-input>
        </el-form-item>

        <el-form-item label="交易区" prop="tradeSet">
          <!-- <el-input v-model="tradePair.tradeSet"></el-input> -->
          <el-select
            v-model="tradePair.tradeSet"
            placeholder="请选择"
            @change="selectSubList"
          >
            <el-option
              v-for="item in fristList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子交易区">
          <!-- <el-input v-model="tradePair.subTradeSet"></el-input> -->
          <el-select
            v-model="tradePair.subTradeSet"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in subList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Icon 中文">
          <upload
            v-model="tradePair.iconZh"
            :data="{ language: 1, platform: 1 }"
          ></upload>
        </el-form-item>
        <el-form-item label="Icon 中文描述">
          <el-input v-model="tradePair.descZh"></el-input>
        </el-form-item>
        <el-form-item label="Icon 英文">
          <upload
            v-model="tradePair.iconEn"
            :data="{ language: 4, platform: 1 }"
          ></upload>
        </el-form-item>
        <el-form-item label="Icon 英文描述">
          <el-input v-model="tradePair.descEn"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('tradePair')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import upload from "../../../../../components/upload";
import coinSelect from "../../../../../components/coinSelect";
import api from "../../api";

export default {
  name: "CreateTradePair",
  components: { upload, coinSelect },
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      defaultDate: new Date(),
      tradePair: {
        exchangeCoin: "",
        anchoredCoin: "",
        defaultPrecision: "",
        amountPrecision: "",
        shouldDisplay: true,
        supportTrade: false,
        supportBid: false,
        supportAsk: false,
        earliestBidTime: "",
        earliestAskTime: "",
        realOnlineTime: "",
        onlineTime: "",
        highRisk: false,
        bidFeeRate: "",
        askFeeRate: "",
        minimumTradeVolume: "",
        feeRate: "",
        futures: false,
        beginTime: "",
        websiteUrl: "",
        iconZh: "",
        iconEn: "",
        descZh: "",
        descEn: "",
        supportVirtualSets: [],
        tradeSet: "",
        subTradeSet: [],
      },
      virtualSets: [],
      earliestBidTime: "",
      earliestAskTime: "",
      realOnlineTime: "",
      beginTime: 0,
      rules: {
        exchangeCoin: [{ required: true, message: "请选择交易目标币种" }],
        anchoredCoin: [{ required: true, message: "请选择锚定币种" }],
        defaultPrecision: [{ required: true, message: "请输入价格精度" }],
        amountPrecision: [{ required: true, message: "请输入数量精度" }],
        bidFeeRate: [{ required: true, message: "请输入交易买费率" }],
        askFeeRate: [{ required: true, message: "请输入交易卖费率" }],
        minimumTradeVolume: [{ required: true, message: "请输入最小交易额" }],
        tradeSet: [{ required: true, message: "请输入交易区code" }],
      },
      allList: [],
      fristList: [],
      subList: [],
    };
  },
  computed: {
    ...mapGetters("tradePairSetting", ["coinList", "tradeArea"]),
    /* ...mapState("tradePairSetting",['virtualTradeSet'])*/
  },
  mounted() {
    this.queryTradeRangeList();
  },
  methods: {
    ...mapActions("tradePairSetting", ["create"]),
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        // const subTradeSet = this.tradePair.subTradeSet.join();
        const subTradeSet = this.tradePair.subTradeSet.toString();
        if (!this.earliestBidTime) {
          this.$message({
            showClose: true,
            message: "请选择最早买单时间",
            type: "error",
          });
          return;
        }
        if (!this.earliestAskTime) {
          this.$message({
            showClose: true,
            message: "请选择最早卖单时间",
            type: "error",
          });
          return;
        }
        if (!this.realOnlineTime) {
          this.$message({
            showClose: true,
            message: "请选择真实上线时间",
            type: "error",
          });
          return;
        }
        if (this.tradePair.futures && this.beginTime === "") {
          this.$message.error("期货兑换开始时间不能为空");
          return;
        }
        if (valid) {
          if (this.earliestBidTime)
            this.tradePair.earliestBidTime = this.earliestBidTime.getTime();
          if (this.earliestAskTime)
            this.tradePair.earliestAskTime = this.earliestAskTime.getTime();
          if (this.realOnlineTime)
            this.tradePair.realOnlineTime = this.realOnlineTime.getTime();
          // if (this.onlineTime)
          //   this.tradePair.onlineTime = this.onlineTime.getTime();
          if (this.beginTime) {
            this.tradePair.beginTime = this.beginTime.getTime();
          }

          for (let index in this.virtualSets) {
            this.tradePair.supportVirtualSets =
              this.tradePair.supportVirtualSets + this.virtualSets[index] + ",";
          }

          this.create({ ...this.tradePair, subTradeSet }).then(() => {
            this.$message.success("添加成功！");
            this.dialogVisible = false;
            this.$emit("refresh", { page: 1 });
            this.earliestBidTime = "";
            this.earliestAskTime = "";
            this.realOnlineTime = "";
            this.onlineTime = "";
            this.virtualSets = [];
            this.tradePair.supportVirtualSets = "";
          });
        }
      });
    },
    closeDialog() {
      this.$refs["tradePair"].resetFields();
      this.tradePair.subTradeSet = [];
      this.earliestBidTime = "";
      this.earliestAskTime = "";
      this.realOnlineTime = "";
      this.onlineTime = "";
    },
    queryTradeRangeList() {
      api.listTradeRange({ page: 1, size: 999 }).then((res) => {
        this.allList = res.data;
        res.data.forEach((item) => {
          if (item.level == 1) {
            this.fristList.push(item);
          } else if (item.level == 2) {
            this.subList.push(item);
          }
        });
      });
    },
    selectSubList(val) {
      this.subList = [];
      this.allList.forEach((item) => {
        if (item.supCode == val) {
          this.subList.push(item);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.realkline-wrap {
  padding-top: 22px;
  border-top: 1px solid #ededed;
}
</style>
